<template>
  <div class="outrasSolucoes">
    <div class="auto-container">
      <div class="title-group">
        <span class="sectionTitle" v-html="fc_getText(null, 'outrasSolucoes')"></span>
        <div class="subtitulo" v-html="fc_getText(null, 'outrasSolucoes_titulo')"></div>
      </div>
      <div class="outrasSolucoes-blocks flex flex-wrap">
        <div v-for="(forItem, forIndex) in solucoes.list" :key="forIndex" :item="forItem" class="outrasSolucoes-block w-full md:w-6 lg:w-4">
          <div class="inner-box">
            <div @click="fc_goRoute('solucao', { id: forItem.id })" class="cursorPointer icon-box wow fade-in-left">
              <img :src="forItem.logotipo" style="max-width:80%;" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: false,
      solucoes: {
        list: []
      },
    };
  },
  props: {
    solucao: Number
  },
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      if (this.solucoes.list != null && this.solucoes.list.length > 0) {
        if (this.solucoes.list.length > 3) {
          let findIndex = this.solucoes.list.findIndex((o) => o.id === this.solucao)
          if (findIndex > -1) {
            this.solucoes.list.splice(findIndex, 1);
          }
        }
        this.solucoes.list = this.solucoes.list.slice(0, 3);
      }
      this.loaded = true;
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'Solucoes/', method: 'GET', success: (response) => { this.fc_responseList(response, this.solucoes.list); resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
  .outrasSolucoes {
    position: relative;
    padding: 100px 0 60px;
  }
  .outrasSolucoes .title-group {
    margin-bottom: 65px;
  }
  .outrasSolucoes .sectionTitle:before {
    background-color: black;
  }
  .outrasSolucoes .outrasSolucoes-blocks {
    position: relative;
    justify-content: center;
  }
  .outrasSolucoes .outrasSolucoes-block {
    position: relative;
    padding: 0 75px;
    margin-bottom: 50px;
    z-index: 1;
  }
  .outrasSolucoes .outrasSolucoes-blocks .outrasSolucoes-blocks-container {
    margin: 0 -75px;
  }
  .outrasSolucoes-block .inner-box {
    position: relative;
    text-align: center;
  }
  .outrasSolucoes-block .icon-box{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 240px;
    width: 240px;
    margin: 0 auto 40px;
    border-radius: 50%;
    border: 2px dashed #dedede;
  }
  .outrasSolucoes-block .icon-box img {
    max-width: 60%;
    max-height: 60%;
    object-fit: contain;
    transition: all 300ms ease;
  }
  .outrasSolucoes-block .inner-box:hover .icon-box img {
    transform: scale(1.1);
  }
  @media only screen and (max-width: 767px) {
    .outrasSolucoes {
      padding-top: 70px;
    }
  }
  @media only screen and (max-width: 1140px) {
    .outrasSolucoes .outrasSolucoes-block {
        padding: 0 15px;
    }
  }
</style>
